import apiClient from "@/services/apiClient";

export const preClassPreparationService = {
  get: (studentBookingId) => apiClient.get("/CourseProgress/PreClassPreparation", { params: { pStudentBookingId: studentBookingId } }).then((response) => response.data),
  save: (payload) => apiClient.post("/CourseProgress/SavePreClassPreparation", payload).then((response) => response.data),
  submit: (payload) => apiClient.post("/CourseProgress/CompletePreClassPreparation", payload).then((response) => response.data),
};
